"use strict";

var _objectWithoutProperties = require("/home/gajewsky/code/smooth-ui/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreSc = require("@smooth-ui/core-sc");

var paths = _interopRequireWildcard(require("./paths"));

var _AnimatedShield = _interopRequireDefault(require("./AnimatedShield"));

var _NavHeader = _interopRequireDefault(require("./NavHeader"));

var _NavLink = _interopRequireDefault(require("./NavLink"));

var _Shield = _interopRequireDefault(require("./Shield"));

var _NavLinkList = _interopRequireDefault(require("./NavLinkList"));

var _NavLinkItem = _interopRequireDefault(require("./NavLinkItem"));

var _NavLogo = _interopRequireDefault(require("./NavLogo"));

var _NavBody = _interopRequireDefault(require("./NavBody"));

var locales = _interopRequireWildcard(require("./locales"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var RawLink = function RawLink(_ref) {
  var to = _ref.to,
      props = _objectWithoutProperties(_ref, ["to"]);

  return _react["default"].createElement("a", _extends({
    href: to
  }, props));
};

var Header = function Header(_ref2) {
  var variant = _ref2.variant,
      logo = _ref2.logo,
      _ref2$linkComponent = _ref2.linkComponent,
      Link = _ref2$linkComponent === void 0 ? RawLink : _ref2$linkComponent,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? 'en' : _ref2$locale;
  return _react["default"].createElement(_NavHeader["default"], {
    linkComponent: Link,
    variant: variant,
    locale: locale
  }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_NavLogo["default"], {
    mobileOnly: true
  }, _react["default"].createElement(Link, {
    to: paths.HOME
  }, _react["default"].createElement(_Shield["default"], {
    style: {
      width: 'auto',
      height: '100%'
    }
  }))), _react["default"].createElement(_NavBody["default"], null, _react["default"].createElement(_coreSc.Row, null, _react["default"].createElement(_coreSc.Col, {
    xs: 12,
    md: "auto",
    display: {
      xs: 'block',
      md: 'flex'
    },
    alignItems: "center"
  }, _react["default"].createElement(_NavLinkList["default"], null, _react["default"].createElement(_NavLinkItem["default"], null, _react["default"].createElement(_NavLink["default"], {
    as: Link,
    to: paths.PROJECTS
  }, locales[locale].projects)), _react["default"].createElement(_NavLinkItem["default"], null, _react["default"].createElement(_NavLink["default"], {
    as: Link,
    to: paths.WORKSHOPS
  }, locales[locale].trainings)))), _react["default"].createElement(_coreSc.Col, {
    xs: true,
    display: {
      xs: 'none',
      md: 'flex'
    },
    alignItems: "center",
    justifyContent: "center"
  }, logo !== false && _react["default"].createElement(Link, {
    to: paths.HOME,
    style: {
      display: 'block',
      height: 45
    }
  }, _react["default"].createElement(_AnimatedShield["default"], {
    height: 45
  }))), _react["default"].createElement(_coreSc.Col, {
    xs: 12,
    md: "auto",
    display: {
      xs: 'block',
      md: 'flex'
    },
    alignItems: "center"
  }, _react["default"].createElement(_NavLinkList["default"], null, _react["default"].createElement(_NavLinkItem["default"], null, _react["default"].createElement(_NavLink["default"], {
    as: Link,
    to: paths.ARTICLES
  }, locales[locale].blog)), _react["default"].createElement(_NavLinkItem["default"], null, _react["default"].createElement(_NavLink["default"], {
    as: Link,
    to: paths.OPEN_SOURCE
  }, locales[locale].openSource))))))));
};

var _default = Header;
exports["default"] = _default;